import React from 'react';
import noPic from '../../assets/no-pic.png';
import './TrendingCategoriesBar.css';

function TrendingCategoriesBar({ categories = [] }) {
  return (
    <div className="tcb-root">
      <div className="tcb-heading">
        <span className="tcb-title">Trending Categories</span>
      </div>
      <div className="tcb-icons">
        {categories.length === 0 ? (
          <span className="tcb-empty">No categories available</span>
        ) : (
          categories.map(cat => (
            <div key={cat.id} className="tcb-icon-item">
              <img
                src={cat.image || noPic}
                alt={cat.name}
                className="tcb-icon-img"
              />
              <span className="tcb-icon-label">{cat.name}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default TrendingCategoriesBar;
